import React from 'react';
import { DateDisplay } from "../";
import { IconButton } from "../buttons";
import { ThemedSpan } from "../utilities";
import { ButtonGroup } from "react-bootstrap";
import { EmailCommands } from './types';

export type EmailHeaderProps = {
    bccRecipients?: string[] | null
    ccRecipients?: string[] | null
    commands: EmailCommands
    extraButtons?: React.ReactNode | null
    fromEmail: string
    sentDate: string
    toRecipients: string[]
};

const EmailHeader = ({
    bccRecipients = null,
    ccRecipients = null,
    commands: {
        onForward,
        onReply,
        onReplyAll
    },
    extraButtons = null,
    fromEmail,
    sentDate,
    toRecipients
}: Readonly<EmailHeaderProps>) => (
    <div className="d-flex justify-content-between mb-2">
        <div className="d-flex flex-row align-items-center">
            <div className="d-flex flex-column">
                <ThemedSpan><b>{fromEmail}</b></ThemedSpan>
                <ThemedSpan>To: {toRecipients.join(", ")}</ThemedSpan>
                {ccRecipients && ccRecipients.length > 0 && <ThemedSpan>Cc: {ccRecipients.join(", ")}</ThemedSpan>}
                {bccRecipients && bccRecipients.length > 0 && <ThemedSpan>Bcc: {bccRecipients.join(", ")}</ThemedSpan>}
            </div>
        </div>
        <div className="d-flex flex-column gap-1">
            <ButtonGroup>
                <IconButton icon={['fas', 'reply']} size={"sm"} onClick={onReply}>
                    Reply
                </IconButton>
                <IconButton icon={['fas', 'reply-all']} size={"sm"} onClick={onReplyAll}>
                    Reply All
                </IconButton>
                <IconButton icon={['fas', 'share']} size={"sm"} onClick={onForward}>
                    Forward
                </IconButton>
                {extraButtons}
            </ButtonGroup>
            <ThemedSpan className="text-end">
                <DateDisplay format="ddd Do MMM YYYY HH:mm">{sentDate}</DateDisplay>
            </ThemedSpan>
        </div>
    </div>
)

export default EmailHeader;